import React from 'react'

const Waves = () => {
  return (
    <div>
        <div className='rectangle w-full bg-teal h-72 pt-48 md:pt-48'>
            <h1 className='text-gray-50 text-center text-xl bg-teal h-16  font-bold mb-8
            md:text-3xl'>Explore different
             Destinations And share Your Experience!</h1>
        </div>
        <svg className='-mt-1' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
           <path fill="teal" fillOpacity="1" d="M0,160L30,144C60,128,120,96,180,90.7C240,85,300,107,360,
                133.3C420,160,480,192,540,202.7C600,213,660,203,720,170.7C780,139,840,85,900,90.7C960,96,
                1020,160,1080,176C1140,192,1200,160,1260,160C1320,160,1380,192,1410,208L1440,224L1440,
                0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,
                0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z">
            </path>
        </svg>

       
    </div>
  )
}

export default Waves